import React from "react";
import { ConsoleUIContext } from "@os1-platform/console-ui-react";

function Initiate(props) {
  const consoleInstance = React.useContext(ConsoleUIContext);
  if (consoleInstance) {
    props.setConsole(consoleInstance);
  }
  return null;
}

export default Initiate;
